// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "eea27b7a308d83fec46c39d0f1f17d2b0de6ee59",
  version: "1.123.1",
};
